export const ServicesHeader = () => {
  return (
    <article className="header">
      <h3>High Quality UFC Apparel</h3>
      <p>50% OFF SELECT UFC VENUM FIGHT NIGHT STYLES</p>
      <p>SAVE ON THE ULTIMATE PERFORMANCE APPAREL!</p>
    </article>
  );
};
